module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT ParaOverride-1",
    attrs: {
      "id": "_idParaDest-3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "HT"
  }, [_vm._v("CARDIFF, BY THE SEA")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Four Novellas")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("of Suspense")])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Joyce Carol Oates")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Mysteriouslogo.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-7"
  }, [_vm._v("The Mysterious Press")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-368ed3f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802158017-2.vue
// module id = 69
// module chunks = 0